import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '@/main'
import { auth } from '@/main'
import router from '../router'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: '',
    items: null,
    logged: false
  },

  getters: {

    getUser: state => {
      return state.user
    },

    getItems: state => {
      return state.items
    },

    getlogged: state => {
      return state.logged
    }

  },
  mutations: {

    addUser(state, items) {
      state.user = items.email;
      state.logged = true;
    },

    checkUser(state, items) {
      state.user = items.email;
      state.logged = true;
    },

    logoutUser(state) {
      state.user = '';
      state.logged = false;
    },

    setItem(state, items) {
      var useritem = items.filter(item => item.email == state.user)
      state.items = useritem
    },

    addTodo(state, items) {
      state.items = [...state.items, items]
    },

    deleteTodo(state, id) {
      state.items = state.items.filter(item => item.id != id)
    }

  },

  actions: {

    checkUser({ commit }, payload) {
      auth.signInWithEmailAndPassword(payload.email, payload.password)
        // eslint-disable-next-line no-unused-vars
        .then(cred => { commit('checkUser', payload);
        localStorage.setItem("loggeduser", "true");
        router.push('todolist')
       })
        .catch(err => {
          alert(err);
          
        })
    },

    addUser({ commit }, payload) {
      auth.createUserWithEmailAndPassword(payload.email, payload.password)
        // eslint-disable-next-line no-unused-vars
        .then(cred => { commit('addUser', payload) ;
        localStorage.setItem("loggeduser", "true");
        router.push('todolist')})
        .catch(err => alert(err))
    },

    logoutUser(context) {
      context.commit('logoutUser')
      auth.signOut()
        // eslint-disable-next-line no-unused-vars
        .then(cred => { localStorage.setItem('loggeduser', 'false') })
        .catch(err => alert(err))
    },

    setItems(context) {
      auth.onAuthStateChanged(user => {
        if (user) {
          let items = []
          db.collection('items').orderBy('created_at').onSnapshot((snapshot) => {
            items = []
            snapshot.forEach((doc) => {
              items.push({ id: doc.id, title: doc.data().title, email: doc.data().email })
            })
            context.commit('setItem', items)
          })
        }
        else { console.log('user logged out'); }
      })
    },

    addTodo({ commit }, payload) {
      commit('addTodo', payload.title)
      db.collection('items').add(payload).then((response) => {
        if (response) {
          // eslint-disable-next-line no-console
          console.log(response);
        }
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      })
    },

    detetItem({ commit }, id) {
      if (id) {
        commit('addTodo', id)
        db.collection("items").doc(id).delete().then(function () {

        }).catch(function (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        })
      }
    }

  },

  modules: {
  }

})
